// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGSeriesIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGSeriesIcon extends PureComponent<
  ISVGSeriesIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.32,32.196c0-1.779,0-3.56,0-5.339c0-6.827,0-13.657,0-20.483
		c-0.195-0.186-0.429-0.461-0.583-0.68c-1.434-0.33-3.594-0.209-5.339-0.194c0.015-1.095-0.104-1.543-0.485-2.136
		c-1.058-0.269-2.72-0.208-4.077-0.194c-0.396-4.009-6.685-3.925-6.699,0c-0.937-0.009-3.326-0.231-3.98,0.097
		C9.933,3.379,9.776,3.696,9.575,3.849C9.516,4.324,9.471,4.899,9.478,5.5C7.828,5.488,4.435,5.062,3.75,6.083
		C3.459,6.515,3.556,7.414,3.556,8.121c0,1.553,0,3.106,0,4.659c0,5.113,0,10.227,0,15.339c0,2.269-0.221,5.352,0.419,6.273
		c0.486,0.485,4.971,0.521,7.251,0.521c4.464,0,8.931,0,13.396,0c1.53,0,5.933,0.318,6.504-0.485
		C31.445,33.981,31.32,32.934,31.32,32.196z M15.594,2.587c0.279-0.282,0.641-0.663,0.874-0.971c0.27-0.031,0.51-0.07,0.68-0.194
		c1.166,0.009,1.386,0.433,2.039,0.874c0.298,1.146,0.078,2.104-0.874,2.524c-1.083,0.476-2.39-0.23-2.621-0.971
		C15.433,3.486,15.55,3.059,15.594,2.587z M29.282,32.973c-7.895,0-15.792,0-23.688,0c-0.024-8.628,0.201-17.032,0-25.532
		c1.294,0,2.589,0,3.883,0c0,0.388,0,0.776,0,1.165c5.306,0,10.614,0,15.921,0c0-0.389,0-0.777,0-1.165c1.294,0,2.589,0,3.883,0
		C29.282,15.951,29.282,24.463,29.282,32.973z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.293,12.975c-1.382,0.044-1.16-0.408-1.748-1.068
		c-0.131-0.142-0.752,0.354-0.971,0.486c0.076,0.274,0.102,0.338,0.291,0.485c-0.093,0.078-0.266,0.143-0.388,0.194
		c0,1.003,0,2.007,0,3.009c1.132,0,2.265,0,3.397,0c0-0.744,0-1.488,0-2.232c0.874-0.647,1.748-1.294,2.621-1.942
		c0-0.615,0-1.229,0-1.844C14.755,10.533,12.757,12.271,12.293,12.975z M12.1,15.401c-0.616,0-1.23,0-1.845,0
		c0-0.582,0-1.165,0-1.747c0.097,0,0.194,0,0.291,0c0.238,0.454,0.608,0.742,0.875,1.165c0.343-0.063,0.328-0.066,0.485-0.292
		c0.065,0,0.129,0,0.195,0C12.1,14.819,12.1,15.111,12.1,15.401z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.399,13.654c0,0.227,0,0.453,0,0.68c-3.526,0-7.055,0-10.582,0
		c-0.009-0.306-0.045-0.506,0-0.583c0.547-0.34,2.147-0.097,2.913-0.097C20.286,13.654,22.842,13.654,25.399,13.654z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.399,14.819c0,0.227,0,0.453,0,0.68c-3.526,0-7.055,0-10.582,0
		c-0.014-0.417-0.036-0.361,0-0.68C18.344,14.819,21.873,14.819,25.399,14.819z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.817,20.159c3.527,0,7.056,0,10.582,0c0,0.226,0,0.453,0,0.679
		c-2.427,0-4.854,0-7.281,0c-1.042,0-2.537,0.188-3.398-0.096C14.778,20.573,14.807,20.436,14.817,20.159z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.196,19.479c0,0.032,0,0.064,0,0.098
		c-1.537,0.034-0.934-0.45-1.65-1.069c0-0.032,0-0.064,0-0.096c-0.399,0.135-0.543,0.372-0.971,0.485
		c0.063,0.343,0.067,0.328,0.291,0.484c0,0.065,0,0.13,0,0.195c-0.129,0-0.258,0-0.388,0c0,1.035,0,2.071,0,3.106
		c1.132,0,2.265,0,3.397,0c0-0.744,0-1.489,0-2.233c0.874-0.647,1.748-1.294,2.621-1.942c0-0.614,0-1.229,0-1.844
		C14.376,17.074,13.302,19.085,12.196,19.479z M12.1,22.003c-0.616,0-1.23,0-1.845,0c0-0.583,0-1.165,0-1.747
		c0.644,0.129,0.738,0.724,1.165,1.068c0.1,0.078,0.023,0.036,0.194,0.097c0.137-0.147,0.269-0.213,0.388-0.389
		c0.032,0,0.064,0,0.098,0C12.1,21.356,12.1,21.68,12.1,22.003z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.399,21.42c0,0.227,0,0.453,0,0.68c-3.526,0-7.055,0-10.582,0
		c0-0.227,0-0.453,0-0.68C18.308,21.343,21.944,21.21,25.399,21.42z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.817,26.759c3.527,0,7.056,0,10.582,0c0,0.227,0,0.454,0,0.68
		c-3.526,0-7.055,0-10.582,0C14.817,27.213,14.817,26.986,14.817,26.759z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.875,26.177c-1.133,0-2.265,0-3.397,0c0,1.003,0,2.006,0,3.01
		c0.985,0.172,2.326-0.224,3.301,0.097C13.04,28.513,12.889,27.126,12.875,26.177z M12.1,28.507c-0.616,0-1.23,0-1.845,0
		c0-0.55,0-1.1,0-1.65c0.614,0,1.229,0,1.845,0C12.1,27.407,12.1,27.958,12.1,28.507z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.817,27.924c3.527,0,7.056,0,10.582,0c0,0.227,0,0.454,0,0.68
		c-3.526,0-7.055,0-10.582,0C14.817,28.378,14.817,28.151,14.817,27.924z"
          />
        </g>
      </svg>
    );
  }
}
